import React from "react"
import { Spinner } from "reactstrap"

const Spinners = () => {
  return (
    <div
      className="page-content d-flex align-items-center justify-content-center"
      style={{ minHeight: "calc(100vh - 120px)" }}
    >
      <Spinner color="primary" />
    </div>
  )
}

export default Spinners
